export const APPLICATION_CATEGORY = {
    Event: "event"
}